// Partner page data - add new partners here
// Each partner has a unique slug used in the URL: /partners/{slug}

export const PARTNERS = {
  // Example partner template:
  // "partner-slug": {
  //   partner_name: "Partner Company Name",
  //   partner_logo: "/images/partners/partner-logo.png", // or external URL
  //   hook: "Short compelling hook for the partnership",
  //   intro: "Two sentence introduction about why this partnership makes sense. Second sentence explaining the value proposition.",
  //   case_1_img: "/images/projects/Example1.JPG",
  //   case_1_caption: "Description of first relevant project",
  //   case_2_img: "/images/projects/Example2.JPG",
  //   case_2_caption: "Description of second relevant project",
  //   case_3_img: "/images/projects/Example3.JPG",
  //   case_3_caption: "Description of third relevant project",
  //   how_bullets: [
  //     "First way we'd collaborate together",
  //     "Second way we'd work on projects",
  //     "Third benefit of the partnership"
  //   ],
  //   cta_body: "Custom call-to-action text for this partner."
  // },

  "sample-architect": {
    partner_name: "Sample Architecture Studio",
    partner_logo: null, // Will show placeholder if null
    hook: "Quality builds for quality designs",
    intro: "Your designs deserve a builder who reads drawings carefully and executes to spec. TJP delivers the craftsmanship your residential clients expect.",
    case_1_img: "/images/projects/Extension1.JPG",
    case_1_caption: "Rear extension with bi-fold doors",
    case_2_img: "/images/projects/Loft1.JPG",
    case_2_caption: "Loft conversion with dormer",
    case_3_img: "/images/projects/Kitchen1.JPG",
    case_3_caption: "Full kitchen installation",
    how_bullets: [
      "You send drawings, we provide detailed fixed-price quote",
      "Regular progress updates at key stages",
      "Direct line to Tony throughout the build"
    ],
    cta_body: "Let's discuss how we can support your upcoming projects."
  }
};

export const getPartnerBySlug = (slug) => {
  return PARTNERS[slug] || null;
};
